import { useState, useContext } from "react";
import { contextWrapper } from "../MainApp";
import Button from "./Button/Button";
import Welcome from "./steps/Welcome/Welcome";
import LightPoint from "./steps/LightPoint/LightPoint";
import LanguageMessage from "../LanguageMessage/LanguageMessage";
import "./Guide.scss";
const stepData = [
  "welcome",
  "changeLanguage",
  "data",
  "focusMode",
  "editMode",
  "markMode",
  "createMode",
  "optimization",
  "printReport",
];
// inset 0 0 1px 171px rgba(59,66,72,.6),0 0 0 92px rgba(60,67,73,.6)!important
const Guide = () => {
  const { setGlobalState } = useContext(contextWrapper);
  const [step, setStep] = useState(0);
  return (
    <main className="guide">
      {step === 0 ? (
        <Welcome />
      ) : (
        <LightPoint step={step} stepData={stepData} />
      )}
      <div className="cover position-fixed w-100 h-100 " />

      <div
        className="control d-flex rounded-3-top align-items-center justify-content-between 
      w-100  position-fixed"
      >
        {!!step && (
          <Button text="back" step={step} setStep={setStep} back={true} />
        )}
        {step === 0 && (
          <span
            className="skip bg-tertiary rounded-1 cursor-pointer"
            onClick={() => {
              let data = JSON.parse(localStorage.getItem("user"));
              let newData = {
                ...data,
                guide: false,
              };
              setGlobalState(newData);
              localStorage.setItem("user", JSON.stringify(newData));
            }}
          >
            <LanguageMessage message="skip" />
          </span>
        )}
        {step === 8 && (
          <span
            className="skip bg-tertiary rounded-1 cursor-pointer"
            onClick={() => {
              let data = JSON.parse(localStorage.getItem("user"));
              let newData = {
                ...data,
                guide: false,
              };
              setGlobalState(newData);
              localStorage.setItem("user", JSON.stringify(newData));
            }}
          >
            <LanguageMessage message="finish" />
          </span>
        )}
        {step < 8 && <Button text="next" step={step} setStep={setStep} />}
      </div>
    </main>
  );
};
export default Guide;
